import {Erro} from "./Erro";

export class ResultadoValidacaoAditivo {
  ideAditivo: number;
  idePac: number;
  ideCompil: number;
  dataValidacao: Date;
  erros: Erro[];
}
